export function followAppLink(history, path, event) {
    const modified = event && (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1);
    if (modified) {
        if (event.preventDefault) event.preventDefault();
        window.open(path, '_blank');
        return;
    }
    if (event && event.preventDefault) event.preventDefault();
    if (history) {
        history.push(path);
    } else {
        window.location.assign(path);
    }
}
